

















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LineOpacityController extends Vue 
{
    @Prop() layer! : LineLayer | CurveLayer;

    private get opacity()
    {
        return this.layer.opacity;
    }

    private set opacity(opacity)
    {
        this.changeLayerProperty("opacity", Number(opacity), false, false);
    }

    private get opacityText()
    {
        return this.layer.opacity.toFixed() + "%";
    }

    private onOpacityChanged()
    {
        this.changeLayerProperty("opacity", this.layer.opacity, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
